var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_c('v-icon',{staticClass:"iconHeader"},[_vm._v("mdi-apps")]),_vm._v(" "+_vm._s(_vm.$t("views.homePage.header"))+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }